import './Oursolution.css'
import { Group, Badge, Container, Title, Text, SimpleGrid, Card, Image } from '@mantine/core';
import APimgmt from '../Images/Apiandmgmt.png'
import Webdev from '../Images/Web.png';
import Softwaredev from '../Images/strategy.png';
import Saas from '../Images/infrastructure.png';
import Devops from '../Images/Devops.png'

const mockdata = [
    {
        image: APimgmt,
        title: "Api Mangement & Microservices",
        description: "APIGEE, Red Hat 3Scale, webMethods API gateways with OpenAPI implementation and developer portals.",
    },
    {
        image: Saas,
        title: "Cloud Solutions & Infrastructure ",
        description: "AWS, Azure, OCI, GCP, Oracle Integration Cloud, IaaS, PaaS, SaaS offerings with cloud-native implementations..",
    },
    {
        image: Devops,
        title: "DevOps & SRE",
        description: "Kubernetes, OpenShift, Docker, CI/CD pipelines, deployment automation, and site reliability engineering.",
    },
    {
        image: Softwaredev,
        title: "Enterprise Solutions",
        description: "Oracle Fusion/EBS, Oracle Cloud Infrastructure, Siebel, Oracle BRM, OSM, UIM, and BSS/OSS transformations.",
    },
    {
        image: Webdev,
        title: "Web & Mobile Development",
        description: "Full Stack (Java/.Net), Java Spring Boot, Salesforce, React, Angular development with modern frameworks.",
    },

];





const Oursolution = () => {
    const features = mockdata.map((feature) => (
        <Card
            key={feature.title}
            shadow="md"
            radius="md"
            className="heading-card"
            padding="xl"
        >
            {/* <feature.icon size={50} stroke={2} color={theme.colors.blue[6]} /> */}
            <Image src={feature.image} alt={feature.title} h={50} w={50} />
            <Text fz="lg" fw={700} className={"heading-title"} mt="md" c={'white'}>
                {feature.title}
            </Text>
            <Text fz="sm" c="dimmed" mt="sm">
                {feature.description}
            </Text>
        </Card>
    ));
    return (
        <>
            <Group justify='center' mt={'xl'}>
                <Badge variant="outline" size="lg" p={'lg'} mt={'lg'} className='heading-pills'>
                    Our Solutions
                </Badge>
            </Group>
            <Container mt={"xs"} size={"lg"} data-aos="fade-right">
                <Title ta={'center'} className='heading-as-text' size={'60'}>
                    Digital Integration
                </Title>
                <Group justify='center'>
                    <Text c={'white'} fw={'bold'} className='heading-description' mt={'md'}>
                        End-to-end digital transformation services that modernize your enterprise infrastructure with cutting-edge technology solutions
                    </Text>
                </Group>


                <SimpleGrid cols={{ base: 1, md: 3 }} spacing="xl" mt={50}>
                    {features}
                </SimpleGrid>
            </Container>
        </>
    )
}
export default Oursolution;